import Device from "./DeviceContainer";

export default Device;
